import { useHistory } from "react-router";

const NotFound = () =>{

    const history = useHistory();

    history.push('/');
    
    return <></>
}
export default NotFound;